export const REVENUE_AUTOPILOT_ACCOUNT_ID = 1;
// Temporary global kill switch. Re-enable explicitly only after product review.
export const REVENUE_AUTOPILOT_ENABLED = false;

const normalizeAccountId = accountId => {
  if (Number.isInteger(accountId)) return accountId;
  if (typeof accountId !== 'string' || !/^\d+$/.test(accountId)) return null;
  return Number(accountId);
};

export const isRevenueAutopilotEnabledForAccount = accountId =>
  REVENUE_AUTOPILOT_ENABLED &&
  normalizeAccountId(accountId) === REVENUE_AUTOPILOT_ACCOUNT_ID;
